module.exports = __webpack_public_path__ + "img/microplan.34bfb2ba.png";